export default function get({ url, axios, opts = {} }) {
  return axios.get(url, opts).then(r => r.data)
}



// WEBPACK FOOTER //
// ./src/api/get.js